module.exports = {"130630100":"涞源镇","130630101":"银坊镇","130630102":"走马驿镇","130630103":"水堡镇","130630104":"王安镇","130630105":"杨家庄镇","130630106":"白石山镇","130630107":"南屯镇","130630201":"南马庄乡","130630202":"北石佛乡","130630203":"金家井乡","130630204":"留家庄乡","130630205":"上庄乡","130630206":"东团堡乡","130630207":"塔崖驿乡","130630208":"乌龙沟乡","130630209":"烟煤洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130630.json
// module id = 148
// module chunks = 0